import _ from 'lodash'

export interface AtoneError {
  code: string
  message: string
}

export function parseAtoneErrorCodeAndMessage(errors: any[]): AtoneError[] {
  return errors.reduce<AtoneError[]>(
    (prev, error) => {
      const code = _.get(error, 'code')
      const message = _.get(error, 'messages.0')

      if (!code || !message) {
        return prev
      }

      return prev.find(e => e.code === code && e.message === message) ?
        prev :
        [...prev, { code, message }]
    },
    []
  )
}

export function atoneErrorMessages(errorMessage: string, atoneErrors: AtoneError[]): string {
  if (_.isEmpty(atoneErrors)) {

    return errorMessage
  }

  const additionalMessages = [
    ...atoneErrors.some(e => e.code === 'EATN0348') ? [
      'お届け先の電話番号とアカウント情報の両方の電話番号をお確かめください。アカウント情報はアカウントサービス &gt; 各種情報変更よりご確認いただけます。',
    ] : [],
  ]

  return [
    `${errorMessage}<hr/>`,
    atoneErrors.map(e =>
      `[${e.code}] ${e.message}<br/>`
    ),
    additionalMessages ?
      `<br/>${additionalMessages.join('<br/>')}` :
      '',
  ].join('')
}
